import { useAuthStore } from "service";

export interface UseRole {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  isImpersonating: boolean;
  impersonatedBy: string | null;
}

/**
 * While a super_admin impersonates an organization the API reports `role` as
 * `admin`, so `isSuperAdmin` is only true outside of impersonation.
 */
const useRole = (): UseRole => {
  const { role, isImpersonating, impersonatedBy } = useAuthStore();

  return {
    isAdmin: role === "admin" || role === "super_admin",
    isSuperAdmin: role === "super_admin",
    isImpersonating,
    impersonatedBy,
  };
};

export default useRole;
